import PropTypes from 'prop-types';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { BannerCta } from './BannerCta';
import OText from 'components/CText/OText';
import classnames from 'classnames';

const MobilePlusOverviewBannerView = props => {
  const { copyConfig, ctaConfig, isTwoModules } = props ?? {};
  const { image, headline, subText } = copyConfig ?? {};

  const mobilePlusBannerClass = classnames({
    'desktop-tablet-hide': !isTwoModules,
  });

  const flexInfoClass = classnames('m-format100 margLRAuto', {
    format50: !isTwoModules,
    format100: isTwoModules,
  });

  const flexTitleClass = classnames('m-flex-row', {
    'flex-column': !isTwoModules,
    'flew-row justify-center': isTwoModules,
  });

  const labelImageClass = classnames('m-margR16  m-margB0  m-format40', {
    'margR0 margB8 format30': !isTwoModules,
    'margR16 margB0 width90px': isTwoModules,
  });

  const imageClass = classnames('m-format100', {
    width90px: isTwoModules,
    format100: !isTwoModules,
  });

  return (
    <FlexContainer column className={mobilePlusBannerClass}>
      <FlexContainer column className={flexInfoClass}>
        <FlexContainer column>
          <FlexContainer alignItemsCenter className={flexTitleClass}>
            {image && (
              <Label className={labelImageClass}>
                <img alt={headline} src={image} className={imageClass} />
              </Label>
            )}
            {headline && (
              <Label bold className="margB8 text-18">
                <OText text={headline} />
              </Label>
            )}
          </FlexContainer>
          {subText && (
            <Label className="text-14">
              <OText text={subText} />
            </Label>
          )}
        </FlexContainer>
      </FlexContainer>

      <BannerCta {...ctaConfig} />
    </FlexContainer>
  );
};

MobilePlusOverviewBannerView.propTypes = {
  image: PropTypes.string,
  headline: PropTypes.string,
  subText: PropTypes.string,
  ctaConfig: PropTypes.object,
};

export default MobilePlusOverviewBannerView;
